import { SERVER_URI } from '../Constant/server'
import { apiGet, apiPost, apiPost1, apiPut, apiPut1 } from '../utils/axios'

const LOCATION_URL = SERVER_URI + '/locations';
const GET_LOCATION_LIST = SERVER_URI + '/get-locations';
const CHANGE_LOCATION_LIST = SERVER_URI + '/change-location-status/';
const UPDATE_LOCATION_DATA = SERVER_URI + '/locations/';

const GETLOCATIONBASEDATA = SERVER_URI + '/get-locationData/';

export default {

    addLocation: async function (paylaod) {
        return apiPost1(LOCATION_URL, paylaod);
    },
    getLocationList: async function (paylaod) {
        return apiPost(GET_LOCATION_LIST, paylaod);
    },
    changeLocationList: async function (id) {
        return apiGet(CHANGE_LOCATION_LIST + id);

    },
    updateLocationData: async function (id, payload) {
        return apiPut1(UPDATE_LOCATION_DATA + id, payload)
    },
    getLocationBaseData : async function (id) {
        return apiGet(GETLOCATIONBASEDATA + id)
    },
    
}